import { ThemeConfig } from 'antd';
import { colors } from 'theme/colors';

// !Dark Theme will have its' own colors. eg., darkColors.ts
// colors.ts is for light theme.

// Dark theme color overrides
const darkColors = {
  // Override primary colors to use green for dark theme
  colorPrimary: colors.colorSuccess,
  colorPrimaryHover: colors.colorSuccessHover,
  colorPrimaryActive: colors.colorSuccessActive,

  // Adjust error colors for dark theme
  colorError: colors.colorErrorHover,
  colorErrorHover: colors.colorErrorBg,
  colorErrorActive: colors.colorError,
};

export const darkTheme: ThemeConfig = {
  components: {
    Typography: {
      fontWeightStrong: 500,
      colorLinkHover: '#ffffff',
      colorLinkActive: '#ffffff',
      colorLink: '#ffffff',
    },
    Input: {
      paddingInlineSM: 7,
      paddingInlineLG: 11,
      paddingInline: 11,
      paddingBlockSM: 0,
      paddingBlockLG: 7,
      paddingBlock: 4,
      hoverBorderColor: '#ffffff',
      activeBorderColor: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Transfer: {
      listWidthLG: 250,
      listWidth: 180,
      listHeight: 200,
      itemPaddingBlock: 5,
    },
    Segmented: {
      itemColor: '#ffffff',
    },
    Switch: {
      trackPadding: 2,
      trackMinWidthSM: 28,
      trackMinWidth: 44,
      trackHeightSM: 16,
      trackHeight: 22,
      handleSizeSM: 12,
      handleSize: 18,
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Timeline: {
      itemPaddingBottom: 20,
      colorPrimary: '#ffffff',
    },
    Tabs: {
      horizontalItemGutter: 32,
      cardGutter: 2,
      itemSelectedColor: '#ffffff',
      itemHoverColor: '#ffffff',
      inkBarColor: '#ffffff',
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Table: {
      stickyScrollBarBorderRadius: 100,
      rowHoverBg: '#131110',
      bodySortBg: '#131110',
      fontWeightStrong: 500,
      colorPrimary: '#ffffff',
      colorLink: '#ffffff',
      // railSize: 4,
      // handleSizeHover: 12,
      // dotSize: 8,
      // controlSize: 10,
      // handleSize: 10,
      // handleColorDisabled: '#bfbfbf',
      // handleActiveColor: '#ffffff',
    },
    Steps: {
      dotSize: 8,
      dotCurrentSize: 10,
      fontWeightStrong: 500,
      colorPrimary: '#ffffff',
      // finishIconBorderColor: '#1677ff',
    },
    Spin: {
      dotSizeSM: 14,
      dotSize: 20,
      contentHeight: 400,
      colorPrimary: '#ffffff',
    },
    Slider: {
      railSize: 4,
      handleSizeHover: 12,
      dotSize: 8,
      controlSize: 10,
      handleSize: 10,
      handleActiveColor: '#ffffff',
      handleColorDisabled: '#bfbfbf',
      colorPrimary: '#ffffff',
    },
    Rate: {
      starSize: 20,
    },
    Radio: {
      radioSize: 16,
      dotSize: 8,
      buttonPaddingInline: 15,
      buttonSolidCheckedHoverBg: '#ffffff',
      buttonSolidCheckedBg: '#ffffff',
      // radioBgColor: '#ffffff',
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Popover: {
      titleMinWidth: 177,
      fontWeightStrong: 500,
    },
    Notification: {
      width: 384,
      colorInfo: '#ffffff',
    },
    Menu: {
      subMenuItemBg: '#ffffff',
      darkSubMenuItemBg: '#ffffff',
      darkItemDisabledColor: 'rgba(255, 255, 255, 0.25)',
      darkItemColor: '#ffffff',
      darkGroupTitleColor: 'rgba(255, 255, 255, 0.65)',
      darkItemBg: '#ffffff',
      popupBg: '#ffffff',
      itemSelectedColor: '#ffffff',
      itemSelectedBg: '#ffffff',
      itemHoverColor: '#ffffff',
      itemHoverBg: '#ffffff',
      itemColor: '#ffffff',
      itemBg: '#ffffff',
      horizontalItemSelectedColor: '#ffffff',
      horizontalItemSelectedBg: 'rgba(255, 255, 255, 0.00)',
      horizontalItemHoverColor: '#ffffff',
      horizontalItemHoverBg: 'rgba(255, 255, 255, 0.00)',
      darkItemSelectedBg: '#ffffff',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.00)',
      darkPopupBg: '#ffffff',
      activeBarBorderWidth: 1,
      collapsedWidth: 80,
      dropdownWidth: 160,
      itemMarginInline: 4,
      iconMarginInlineEnd: 10,
      colorPrimary: '#ffffff',
      colorBgContainer: '#ffffff',
    },
    InputNumber: {
      paddingInlineSM: 7,
      paddingInlineLG: 11,
      paddingInline: 11,
      paddingBlockSM: 0,
      paddingBlockLG: 7,
      paddingBlock: 4,
      handleWidth: 22,
      controlWidth: 90,
      hoverBorderColor: '#ffffff',
      handleHoverColor: '#ffffff',
      activeBorderColor: '#ffffff',
      filledHandleBg: '#201d1b',
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Image: {
      previewOperationSize: 18,
      previewOperationHoverColor: 'rgba(255, 255, 255, 0.85)',
      previewOperationColorDisabled: 'rgba(255, 255, 255, 0.25)',
      previewOperationColor: 'rgba(255, 255, 255, 0.65)',
    },
    Card: {
      headerHeightSM: 38,
      headerHeight: 56,
      headerBg: 'rgba(255, 255, 255, 0.00)',
      fontSize: 22,
      fontWeightStrong: 500,
      colorPrimary: '#ffffff',
    },
    Carousel: {
      dotWidth: 16,
      dotHeight: 3,
      dotActiveWidth: 24,
    },
    Cascader: {
      dropdownHeight: 180,
      controlWidth: 184,
      controlItemWidth: 111,
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Calendar: {
      yearControlWidth: 80,
      monthControlWidth: 70,
      fontWeightStrong: 500,
      colorPrimary: '#ffffff',
      colorLinkHover: '#ffffff',
      colorLink: '#ffffff',
      fontSizeSM: 20,
    },
    Button: {
      paddingInlineSM: 7,
      paddingInlineLG: 15,
      paddingInline: 15,
      onlyIconSizeSM: 12,
      onlyIconSizeLG: 18,
      textHoverBg: '#ffffff',
      linkHoverBg: 'rgba(255, 255, 255, 0.00)',
      ghostBg: 'rgba(255, 255, 255, 0.00)',
      defaultHoverColor: '#ffffff',
      defaultHoverBorderColor: '#ffffff',
      fontWeight: 400,
      colorPrimaryHover: '#ffffff',
      colorPrimaryActive: '#ffffff',
      colorPrimary: '#ffffff',
      colorLink: '#ffffff',
    },
    Badge: {
      statusSize: 6,
      indicatorHeight: 20,
      dotSize: 6,
      colorPrimary: '#ffffff',
      fontSize: 22,
    },
    Form: {
      colorPrimary: '#ffffff',
      labelColonMarginInlineStart: 2,
    },
    Avatar: {
      colorTextPlaceholder: '#ffffff',
      // avatarColorLime: '#ffffff',
      // avatarColorCyan: '#ffffff',
      // avatarColorBlue: '#ffffff',
      // avatarColorGeekBlue: '#ffffff',
      // avatarColorGold: '#ffffff',
      // avatarColorMagenta: '#ffffff',
      // avatarColorMint: '#ffffff',
      // avatarColorPrimary: '#ffffff',
      // avatarMauveGrey: '#ffffff',
      // avatarLedgerWhite: '#ffffff',
      // avatarPaperwhite: '#ffffff',
      textFontSize: 18,
    },
    Tour: {
      fontWeightStrong: 500,
      colorPrimary: '#ffffff',
      colorBgTextHover: '#ffffff',
      closeBtnSize: 22,
      primaryNextBtnHoverBg: '#f0f0f0',
      primaryPrevBtnBg: 'rgba(255, 255, 255, 0.15)',
    },
    Upload: {
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
      fontSize: 22,
      fontSizeSM: 20,
    },
    TreeSelect: {
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Tree: {
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
      directoryNodeSelectedBg: '#ffffff',
    },
    Tag: {
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Select: {
      fontWeightStrong: 500,
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
      multipleItemBorderColorDisabled: 'rgba(255, 255, 255, 0.00)',
      multipleItemBorderColor: 'rgba(255, 255, 255, 0.00)',
      showArrowPaddingInlineEnd: 18,
    },
    Result: {
      colorInfo: '#ffffff',
      iconFontSize: 72,
    },
    Progress: {
      defaultColor: '#ffffff',
    },
    Popconfirm: {
      fontWeightStrong: 500,
    },
    Pagination: {
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
      colorBgTextHover: '#ffffff',
    },
    Modal: {
      fontWeightStrong: 500,
      footerBg: 'rgba(255, 255, 255, 0.00)',
      titleFontSize: 16,
    },
    Message: {
      colorInfo: '#ffffff',
    },
    List: {
      colorPrimary: '#ffffff',
      headerBg: 'rgba(255, 255, 255, 0.00)',
      footerBg: 'rgba(255, 255, 255, 0.00)',
    },
    FloatButton: {
      controlItemBgHover: '#ffffff',
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Dropdown: {
      colorPrimary: '#ffffff',
      paddingBlock: 5,
    },
    Drawer: {
      fontWeightStrong: 500,
      lineWidthFocus: 4,
    },
    Descriptions: {
      fontWeightStrong: 500,
    },
    DatePicker: {
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
      colorLink: '#ffffff',
      fontSize: 22,
      fontSizeLG: 24,
      hoverBorderColor: '#ffffff',
      activeBorderColor: '#ffffff',
      paddingInline: 11,
      paddingInlineSM: 7,
      cellHoverWithRangeBg: '#c8dfff',
      cellRangeBorderColor: '#7cb3ff',
      multipleItemBorderColor: 'rgba(255, 255, 255, 0.00)',
      multipleItemBorderColorDisabled: 'rgba(255, 255, 255, 0.00)',
      cellWidth: 36,
      multipleItemHeight: 24,
      multipleItemHeightLG: 32,
      multipleItemHeightSM: 16,
      paddingBlock: 4,
      paddingBlockLG: 7,
      paddingBlockSM: 0,
      paddingInlineLG: 11,
      presetsMaxWidth: 200,
      presetsWidth: 120,
      timeCellHeight: 28,
      timeColumnHeight: 224,
      timeColumnWidth: 56,
      withoutTimeCellHeight: 66,
    },
    Collapse: {
      fontSize: 22,
      fontSizeLG: 24,
    },
    Checkbox: {
      colorPrimaryHover: '#ffffff',
      colorPrimary: '#ffffff',
    },
    Breadcrumb: {
      colorBgTextHover: '#ffffff',
      fontSize: 22,
    },
    Anchor: {
      colorPrimary: '#ffffff',
    },
    Alert: {
      colorInfo: '#ffffff',
    },
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#ffffff',
      triggerBg: '#002140',
      headerHeight: 50,
      triggerHeight: 48,
    },
    Splitter: {
      resizeSpinnerSize: 20,
      splitBarSize: 2,
      splitTriggerSize: 6,
    },
  },
  token: {
    ...colors,
    ...darkColors,
    fontFamily: 'PP Neue Montreal',
    fontWeightStrong: 500,
    colorText: 'white',
    colorBorder: '#434343',
  },
};
